import { SearchAndCourseFeatureFacade } from '../../../../../search_and_add_courses/facades/search_and_courses_feature_facade';
import { TermCourseQuery } from '../../../../term_courses/queries/term_courses_query';
import { CustomContentsServant } from 'data-ng-custom-text';
import { IApplicationConfiguration } from '../../../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { QuickScheduleFacade } from '../../facades/quick_schedule_facade';

interface INavItem {
  id: number;
  title: string;
  icon: string;
  active?: boolean;
  visible: boolean;
  action?: () => void;
}

class SchedulerNavigationItems {
  private quickScheduleEnabled: boolean = false;
  private appointmentFeatureEnabled: boolean = false;

  private navigationItems: INavItem[] = [];
  constructor(
    private $state: ng.ui.IStateService,
    private ngTermCourseQuery: TermCourseQuery,
    private ngCustomContentsServant: CustomContentsServant,
    private appConfigModel: IApplicationConfiguration,
    private $timeout: ng.ITimeoutService,
    private ngSearchAndCourseFeatureFacade: SearchAndCourseFeatureFacade,
    private ngQuickScheduleFacade: QuickScheduleFacade
  ) {}

  $onInit() {
    this.refreshNavigationItems();
  }

  $onChanges() {
    this.refreshNavigationItems();
  }

  getNaviationItems(scheduleLabel: string) {
    this.quickScheduleEnabled = this.appConfigModel.isFeatureEnabled('reg-quick_scheduler');
    this.appointmentFeatureEnabled = this.appConfigModel.isFeatureEnabled('ssccampus-appointment_scheduling');

    return [
      {
        id: 0,
        title: 'My Planned Courses',
        icon: 'calender',
        visible: true,
        active: this.$state.is('my.schedule.registration'),
        action: () => this.$state.go('my.schedule.registration')
      },
      {
        id: 1,
        title: 'Search For Sections',
        icon: 'search',
        visible: true,
        active: this.$state.is('my.schedule.registration.search'),
        action: () => this.$state.go('my.schedule.registration.search')
      },
      {
        id: 2,
        title: 'Search For Courses',
        icon: 'report',
        active: this.$state.is('my.schedule.searchandaddcourses'),
        visible: this.ngSearchAndCourseFeatureFacade.isFeatureEnabled,
        action: () => this.$state.go('my.schedule.searchandaddcourses')
      },
      {
        id: 3,
        title: 'Transaction History',
        icon: 'book',
        visible: true,
        active: this.$state.is('my.schedule.transactions'),
        action: () => this.$state.go('my.schedule.transactions')
      },
      {
        id: 4,
        title: scheduleLabel,
        icon: 'user',
        visible: this.appointmentFeatureEnabled,
        external: true,
        action: () => window.open(`${window.location.origin}/app/#/my/host/as3/appointment-new`)
      },
      {
        id: 5,
        title: 'Quick Schedule',
        icon: 'alarm',
        visible: this.quickScheduleEnabled,
        active: this.$state.is('my.schedule.quickscheduler'),
        action: () => this.ngQuickScheduleFacade.quickScheduleAction()
      },
      {
        id: 6,
        title: 'Preferences',
        icon: 'gear',
        visible: true,
        active: this.$state.is('my.schedule.registration.preferences'),
        action: () => this.$state.go('my.schedule.registration.preferences')
      }
    ].filter((item) => item.visible);
  }

  tertiaryMenuClicked(e: MouseEvent) {
    this.navigationItems = _4.map(this.navigationItems, (item) => ({ ...item, active: false }));
    const menuObject = _4.find(this.navigationItems, { id: _4.get(e, 'detail.value.id', 0) });
    if (menuObject.action) {
      menuObject.active = true;
      menuObject.action();
    }
  }

  private refreshNavigationItems() {
    this.ngCustomContentsServant
      .getButtonLabel('Schedule an Appointment')
      .then((label) => {
        this.navigationItems = this.getNaviationItems(label);
      })
      .catch(() => {
        this.$timeout(() => {
          this.navigationItems = this.getNaviationItems('Appointment Schedule');
        });
      });
  }
}
angular.module('capability-ng-scheduler').component('schedulerNavigationItems', {
  templateUrl: 'capability-ng-scheduler/src/views/aside/scheduler_navigation_items/scheduler_navigation_items.html',
  controller: SchedulerNavigationItems
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/aside/scheduler_navigation/components/scheduler_navigation_items/scheduler_navigation_items.ts